import {LogaProxy} from "./LogaProxy";


export class GlobalQuotaConsumptionReportLine {
  consumedQuota: number;

  consumedAndPlannedQuota: number;

  consumedAndRealisedQuota: number;

  availableQuota: number;

  quotaAllowance: number;

}


export class ProfileQuotaConsumptionReport {
  operationProfile: LogaProxy;
  consumedQuota: number;
  consumedAndPlannedQuota: number;
  consumedAndRealisedQuota: number;
  availableQuota: number;
  quotaAllowance: number;
}

export class CustomerSectorHourQuotaConsumptionReport {
  customerSector: LogaProxy;
  operationProfiles: ProfileQuotaConsumptionReport[] = [];
  globalReportLine: GlobalQuotaConsumptionReportLine;
}

export class AreaQuotaHourConsumptionReport {
  area: LogaProxy;
  sectors: CustomerSectorHourQuotaConsumptionReport[] = [];
  globalReportLine: GlobalQuotaConsumptionReportLine;
}

export class OperationHourConsumptionReport {
  operation: LogaProxy;
  globalQuota: number;

  areas: AreaQuotaHourConsumptionReport[] = [];

  globalReportLine: GlobalQuotaConsumptionReportLine;
  consumedAndPlannedQuota: number;
  consumedAndRealisedQuota: number;
  consumedQuota: number;

  unassignedWorkTimePerMission: number;


}

/**
 * Main Object for Quota Report, all previous objects are nested into this one
 */
export class CustomerSectorHourQuotaReport {

  operationReports: OperationHourConsumptionReport[] = [];

}

// --- BUDGET QUOTA Report

export class CustomerSectorBudgetQuotaConsumptionReport {
  customerSector: LogaProxy;
  consumedQuota: number;
  consumedAndPlannedQuota: number;
  consumedAndRealisedQuota: number;
  availableQuota: number;
  quotaAllowance: number;


}


export class AreaQuotaBudgetConsumptionReport {
  area: LogaProxy;
  sectors: CustomerSectorBudgetQuotaConsumptionReport[] = [];
  globalReportLine: GlobalQuotaConsumptionReportLine;
  quotaToDispatchInSectors: number;
  quotaRemainingToDispatchInSectors: number;
}

export class OffQuotaMission {
  missionCode: string;
  storeName: string;
  amount: number;
}

export class OffQuotaReport {
  totalOffQuota: number;
  missions: OffQuotaMission[] = [];
}

export class OperationBudgetConsumptionReport {
  operation: LogaProxy;
  globalQuota: number;
  offQuotaReport: OffQuotaReport;

  areas: AreaQuotaBudgetConsumptionReport[] = [];

  globalReportLine: GlobalQuotaConsumptionReportLine;
  consumedAndPlannedQuota: number;
  consumedAndRealisedQuota: number;
  consumedQuota: number;
  euroToPointQuotaRate: number;

  uiDisplayOffQuotaDetails:boolean;
}

export class BudgetQuotaConsumptionReport {
  operationReports: OperationBudgetConsumptionReport[] = [];
}


//** TRANSFERABLE QUOTA REPORT **/
export class TransferableCustomerOrderQuota {
  operationProfile: LogaProxy;
  customerOrderQuota: number;
  customerSectorName: string;
  customerSectorId: number;

  label: string;

  quota: number;
  availableQuota: number;
}

export class TransferableQuotaOperationWrapper {
  operation: LogaProxy;
  quota: TransferableCustomerOrderQuota[] = [];
}

export class TransferableHourQuotaReport {
  lines: TransferableQuotaOperationWrapper[] = [];
}

/**
 * Request for Quota Transfert
 */
export class CustomerOrderHourlyQuotaTransfer {
  sourceCustomerOrderQuota: number;
  destCustomerOrderQuota: number;
  transferAmount: number;
}

export class CustomerOrderHourlyQuotaTransferReport {
  success: boolean;
  warnings: string[] = [];
}



// WEBPACK FOOTER //
// ./src/model/CustomerSectorHourQuotaReport.ts